import Request from 'shared/api/Request';

export const updateUserPermissions = permissionsToBeUpdated =>
  Request.post('/userPermissions', permissionsToBeUpdated)
    .then(response => response.data);
